import styled from 'styled-components';
import * as React from 'react';
import { Icon } from '../../components/antd';
import * as Headings from '../../components/common';
import * as Colors from '../../constants/colors';

const InlinedIcon = styled(Icon)`
  font-size: 1.7em;
  margin-right: 0.5em;
  color: ${Colors.primaryColor};
`;

const PageTitleH1 = styled(Headings.H1)`
  display: inline-block;
`;

interface Props {
  title: string | React.ReactElement<any>;
  icon: string;
}

export const PageTitle: React.SFC<Props> = props => (
  <div>
    <InlinedIcon type={props.icon} />
    <PageTitleH1>{props.title}</PageTitleH1>
  </div>
);



// WEBPACK FOOTER //
// ./app/components/antd/PageTitle.tsx